import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import Icon from 'Components/UI/Icon';
import { householdPlanStartUri } from 'Consts/advisorUris';
import { getClass, getByLabel } from 'Helpers/PlanType';
import { setPlan } from 'State/actions';

import './index.css';
import { withHousehold } from 'Context/HouseholdContext';
import withEventTrackingLogEvent from 'EventTracking/withEventTrackingLogEvent';

const mapDispatchToProps = dispatch => ({
  set: plan => dispatch(setPlan(plan)),
});

class ExternalPlanBuilderLink extends Component {
  constructor(props) {
    super(props);

    this.handleClick = this.handleClick.bind(this);
  }

  handleClick() {
    const {
      set,
      householdId,
      externalPlanType,
      externalPlanLabel,
      EventTracking,
    } = this.props;
    const { logEvent } = EventTracking;
    const classReference = getClass(getByLabel('External Plan'));
    const core = new classReference(); // eslint-disable-line new-cap
    core.householdID = householdId;
    core.externalPlanType = externalPlanType;
    core.externalPlanLabel = externalPlanLabel;
    set(core);
    logEvent('Clicked External Plan Link', {
      externalPlanType,
      externalPlanLabel,
    });
  }

  render() {
    const { handleClick } = this;
    const {
      externalPlanLabel,
      householdId,
      externalPlanIconSrc,
      EventTracking,
    } = this.props;

    const { rootNodeProps } = EventTracking;
    return (
      <Link
        className="BuilderLink"
        to={householdPlanStartUri(householdId)}
        onClick={handleClick}
        test={`external-plan-${externalPlanLabel}`}
        {...rootNodeProps}
      >
        <div>
          <Icon src={externalPlanIconSrc} />
          <span>{`${externalPlanLabel} Plan`}</span>
        </div>
      </Link>
    );
  }
}

ExternalPlanBuilderLink.propTypes = {
  householdId: PropTypes.number.isRequired,
  externalPlanType: PropTypes.string.isRequired,
  externalPlanLabel: PropTypes.string.isRequired,
  externalPlanIconSrc: PropTypes.string.isRequired,
  set: PropTypes.func.isRequired,
  EventTracking: PropTypes.object.isRequired,
};

export default withEventTrackingLogEvent({}, withHousehold(
  connect(() => ({}), mapDispatchToProps)(ExternalPlanBuilderLink),
));
